<template>
  <b-col sm="12" xl="8">
    <b-navbar
      id="portal-menu"
      toggleable="lg"
      type="dark"
      class="menu-top menu-portal p-0"
    >
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <div class="app-title-sm">Pagamentos de Tributos do Paraná</div>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <template v-for="item in items">
            <template v-if="!item.children">
              <b-nav-item :key="item.key">
                <router-link :to="item.link">{{
                  item.text
                }}</router-link></b-nav-item
              >
            </template>
            <template v-else>
              <b-nav-item-dropdown :key="item.key" :text="item.text">
                <b-dropdown-item
                  v-for="submenu in item.children"
                  :key="submenu.key"
                >
                  <a
                    v-if="isLink(submenu.link)"
                    @click="abrirLink(submenu.link)"
                    >{{ submenu.text }}</a
                  >
                  <router-link v-else :to="submenu.link">{{
                    submenu.text
                  }}</router-link>
                </b-dropdown-item>
              </b-nav-item-dropdown>
            </template>
          </template>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <a ref="linkRedirecionamento" v-show="false" target="_blank"></a>
  </b-col>
</template>

<script>
export default {
  data () {
    return {
      items: [
        { key: 'inicio', text: 'Início', link: '/home' },
        {
          key: 'consultar',
          text: 'Consultar',
          link: '',
          children: [
            {
              key: 'consultar_01_01',
              text: 'Consultar autenticação da GR-PR',
              link: 'https://www.fazenda.pr.gov.br/Pagina/Consulta-autenticacao-da-guia-de-recolhimento-do-estado-do-Parana-GR-PR'
            },
            {
              key: 'consultar_01_02',
              text: 'Consultar Espelho da GR-PR',
              link: 'https://www.fazenda.pr.gov.br/Pagina/Consultar-espelho-GR'
            },
            {
              key: 'consultar_01_03',
              text: 'Consultar Pagamento da GR-PR',
              link: 'https://www.fazenda.pr.gov.br/Pagina/Consultar-pagamento-GR'
            },
            {
              key: 'consultar_02_01',
              text: 'Consultar Espelho de GNRE',
              link: 'https://www.fazenda.pr.gov.br/Pagina/Consultar-espelho-GNRE'
            },
            {
              key: 'consultar_02_02',
              text: 'Consultar Pagamento de GNRE',
              link: 'https://www.fazenda.pr.gov.br/Pagina/Consultar-pagamento-GNRE'
            }
          ]
        },
        {
          key: 'emitir',
          text: 'Emitir',
          link: '',
          children: [
            { key: 'emitir_01', text: 'Emitir GR-PR', link: '/emitir/guia' },
            {
              key: 'emitir_02',
              text: 'Emitir GNRE',
              link: 'https://www.fazenda.pr.gov.br/Pagina/Emissao-da-guia-nacional-de-recolhimento-de-tributos-estaduais-GNRE'
            },
            {
              key: 'emitir_03',
              text: 'Emitir GNRE Portal Nacional',
              link: 'https://www.gnre.pe.gov.br:444/gnre/v/guia/index'
            }
          ]
        },
        {
          key: 'servicos',
          text: 'Serviços',
          link: '',
          children: [
            {
              key: 'retificar_grpr_gnre',
              text: 'Retificar GR-PR e GNRE',
              link: 'https://www.fazenda.pr.gov.br/sites/default/arquivos_restritos/files/documento/2020-08/requerimento_retificacao_guias_recolhimento_anexo_unico_npf_128_2016_editavel.pdf'
            },
            {
              key: 'restituicao',
              text: 'Restituição',
              link: 'https://www.eprotocolo.pr.gov.br/spiweb/protocolarSolicitacao.do?action=iniciarProcesso&codAssunto='
            }
          ]
        },
        {
          key: 'ajuda',
          text: 'Ajuda',
          link: '/ajuda',
          children: [
            {
              key: 'sobre',
              text: 'Perguntas Frequentes',
              link: 'http://www.atendimento.fazenda.pr.gov.br/sacsefa/portal/index'
            }
          ]
        }
      ]
    }
  },
  methods: {
    abrirLink (link) {
      this.$refs.linkRedirecionamento.href = link
      this.$refs.linkRedirecionamento.click()
    },
    isLink (parm) {
      return /^(http|https):\/\/[^\s]+$/.test(parm)
    }
  }
}
</script>

<style lang="scss"></style>
